import React from 'react';
import './Footer.css';
import logo from '../../../../assets/Asset 2.svg';
import { useLanguage } from '../../../../context/LanguageContext';
import translations from '../../../../translations';
import { FaInstagram, FaTiktok, FaFacebookF } from 'react-icons/fa';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const { language } = useLanguage();
  const t = translations[language];

  const handleSocialClick = (e) => {
    e.preventDefault();
    console.log('Social media link clicked - redirects disabled during testing');
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer__content">
          <div className="footer__logo-section">
            <img src={logo} alt="Advanced Elements Logo" className="footer__logo" />
            <div className="footer__contact-info">
              <p>{t.footerAddress}</p>
              <p>{t.footerPhone}</p>
              <p>{t.footerEmail}</p>
            </div>
          </div>

          <div className="footer__links-section">
            <div className="footer__column">
              <h3 className="footer__column-title">{t.socials}</h3>
              <div className="footer__social-icons">
                <a className="footer__social-link" href="https://x.com/advanced_elmts" target="_blank" rel="noopener noreferrer">
                  <svg className="footer__social-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 1227" fill="currentColor">
                    <path d="M714.163 519.284L1160.89 0H1055.03L667.137 450.887L357.328 0H0L468.492 681.821L0 1226.37H105.866L515.491 750.218L842.672 1226.37H1200L714.137 519.284H714.163ZM569.165 687.828L521.697 619.934L144.011 79.6944H306.615L611.412 515.685L658.88 583.579L1055.08 1150.3H892.476L569.165 687.854V687.828Z" />
                  </svg>
                </a>
                <a className="footer__social-link" href="https://www.instagram.com/advanced_elmts" target="_blank" rel="noopener noreferrer">
                  <FaInstagram className="footer__social-icon" />
                </a>
                <a className="footer__social-link" href="https://www.tiktok.com/@advanced_elmts" target="_blank" rel="noopener noreferrer">
                  <FaTiktok className="footer__social-icon" />
                </a>
                <a className="footer__social-link" href="https://www.facebook.com/profile.php?id=61565009836404" target="_blank" rel="noopener noreferrer">
                  <FaFacebookF className="footer__social-icon" />
                </a>
              </div>
            </div>
          </div>

          <div className="footer__copyright">
            <p>© {currentYear} Advanced Elements - {t.footerRights}</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 